import styled from "styled-components"
import _uniqueId from "lodash/uniqueId"
import { Link } from "react-router-dom"

import constants from "utils/constants"

import useMotibellLanding from "hooks/motibell/useMotibellLanding"

export default function MotibellLanding() {
  const { landingDescData, isLoading } = useMotibellLanding()

  if (isLoading) return null
  return landingDescData.map((description) => {
    switch (description.redirect_type) {
      case "external_link":
        return (
          <ExternalLink
            key={_uniqueId("landing-desc-")}
            href={description.redirect_dest}
            target="_blank"
          >
            <LandingDesc
              src={`${constants.imagePath}/motibell/landing_img/${description.filename}`}
            />
          </ExternalLink>
        )
      case "path":
        return (
          <InternalLink key={_uniqueId("landing-desc-")} to={description.redirect_dest}>
            <LandingDesc
              src={`${constants.imagePath}/motibell/landing_img/${description.filename}`}
            />
          </InternalLink>
        )
      default:
        return (
          <LandingDesc
            key={_uniqueId("landing-desc-")}
            src={`${constants.imagePath}/motibell/landing_img/${description.filename}`}
          />
        )
    }
  })
}

const ExternalLink = styled.a`
  cursor: pointer;
`

const InternalLink = styled(Link)`
  cursor: pointer;
`

const LandingDesc = styled.img`
  width: 100%;
  object-fit: cover;
`
